import React, { useState } from "react";

function App() {
  const [loggedIn, setLoggedIn] = useState(false);
  const [view, setView] = useState("drive");
  const [files, setFiles] = useState([]);
  const [search, setSearch] = useState("");
  const [uploading, setUploading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    setLoggedIn(true);
  };

  const getCategory = (name) => {
    if (name.match(/\.(mp4|mkv|avi)$/i)) return "Videos";
    if (name.match(/\.(jpg|png|jpeg)$/i)) return "Images";
    if (name.match(/\.(pdf|docx|txt)$/i)) return "Documents";
    return "Others";
  };

  const handleUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    setTimeout(() => {
      setFiles([
        ...files,
        {
          id: Date.now(),
          name: file.name,
          size: (file.size / 1024).toFixed(1) + " KB",
          category: getCategory(file.name),
          starred: false,
          shared: false,
          trashed: false,
          date: new Date().toLocaleString()
        }
      ]);
      setUploading(false);
    }, 1200);
  };

  const handleDelete = (id) => {
    setFiles(files.map(f => f.id === id ? { ...f, trashed: true } : f));
  };

  const handleRestore = (id) => {
    setFiles(files.map(f => f.id === id ? { ...f, trashed: false } : f));
  };

  const toggleStar = (id) => {
    setFiles(files.map(f => f.id === id ? { ...f, starred: !f.starred } : f));
  };

  const handleShare = (id) => {
    setFiles(files.map(f => f.id === id ? { ...f, shared: true } : f));
  };

  const filteredFiles = files.filter(f => {
    if (view === "drive") return !f.trashed;
    if (view === "shared") return f.shared && !f.trashed;
    if (view === "starred") return f.starred && !f.trashed;
    if (view === "trash") return f.trashed;
    if (view === "recent") return !f.trashed;
    if (view === "downloads") return !f.trashed;
    return true;
  }).filter(f =>
    f.name.toLowerCase().includes(search.toLowerCase())
  );

  if (!loggedIn) {
    return (
      <div style={styles.login}>
        <h2>Cloud Storage Login</h2>
        <form onSubmit={handleLogin} style={styles.loginBox}>
          <input placeholder="Enter Email" required />
          <input type="password" placeholder="Enter Password" required />
          <button type="submit">Login</button>
        </form>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div style={styles.sidebar}>
        <h3>☁ Cloud Drive</h3>
        <p onClick={() => setView("drive")}>My Drive</p>
        <p onClick={() => setView("shared")}>Shared</p>
        <p onClick={() => setView("starred")}>⭐ Starred</p>
        <p onClick={() => setView("recent")}>Recent</p>
        <p onClick={() => setView("downloads")}>Downloads</p>
        <p onClick={() => setView("trash")}>🗑 Trash</p>

        <hr />
        <p>📁 Videos</p>
        <p>📁 Images</p>
        <p>📁 Documents</p>
        <p>📁 Others</p>
      </div>

      <div style={styles.main}>
        <h2>{view.toUpperCase()}</h2>

        <input
          placeholder="Search files..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={styles.search}
        />

        <label style={styles.uploadBtn}>
          Upload File
          <input type="file" hidden onChange={handleUpload} />
        </label>

        {uploading && <p>Uploading file...</p>}

        <ul style={{ padding: 0 }}>
          {filteredFiles.map(file => (
            <li key={file.id} style={styles.fileItem}>
              <div>
                <b>{file.name}</b><br />
                <small>{file.size} | {file.category}</small>
                {file.shared && <small> — Shared</small>}
              </div>

              <div>
                {!file.trashed && (
                  <>
                    <button onClick={() => toggleStar(file.id)}>
                      {file.starred ? "Unstar" : "Star"}
                    </button>
                    <button onClick={() => handleShare(file.id)}>Share</button>
                    <button onClick={() => handleDelete(file.id)}>Delete</button>
                  </>
                )}
                {file.trashed && (
                  <button onClick={() => handleRestore(file.id)}>Restore</button>
                )}
              </div>
            </li>
          ))}
        </ul>

        {filteredFiles.length === 0 && <p>No files found</p>}
      </div>
    </div>
  );
}

const styles = {
  login: {
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  },
  loginBox: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    width: "260px"
  },
  container: {
    display: "flex",
    height: "100vh"
  },
  sidebar: {
    width: "240px",
    background: "#1f2937",
    color: "white",
    padding: "20px",
    cursor: "pointer"
  },
  main: {
    flex: 1,
    padding: "20px"
  },
  uploadBtn: {
    background: "#2563eb",
    color: "white",
    padding: "6px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    display: "inline-block",
    marginBottom: "10px"
  },
  fileItem: {
    listStyle: "none",
    background: "#fff",
    padding: "10px",
    margin: "10px 0",
    display: "flex",
    justifyContent: "space-between",
    borderRadius: "4px"
  },
  search: {
    padding: "6px",
    marginBottom: "10px",
    width: "260px"
  }
};

export default App;